var map = {
	"./1(1).jpg": 6641,
	"./1(3).jpg": 94243,
	"./1.jpg": 46609,
	"./10.jpg": 34038,
	"./12.jpg": 83418,
	"./13.jpg": 60918,
	"./14.jpg": 4689,
	"./15.jpg": 21971,
	"./2.jpg": 10503,
	"./3.jpg": 55657,
	"./4.jpg": 21086,
	"./5.jpg": 48071,
	"./6.jpg": 28240,
	"./7.jpg": 25216,
	"./8.jpg": 36311,
	"./9.jpg": 33079
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95138;